import * as reaction from './reaction';
import * as webAvatarV3 from './webAvatarV3';
import * as webCodeEditorV3 from './webCodeEditorV3';
import * as webFeedbackV3 from './webFeedbackV3';
import * as webInterpretChannelV3 from './webInterpretChannelV3';
import * as webMeetingAuthV3 from './webMeetingAuthV3';
import * as webMeetingOpenAuthV3 from './webMeetingOpenAuthV3';
import * as webMeetingV3 from './webMeetingV3';
import * as webMikeControlV3 from './webMikeControlV3';
import * as webRecordingV3 from './webRecordingV3';
import * as webScreenShareV3 from './webScreenShareV3';
import * as webSettingV3 from './webSettingV3';
import * as webSubtitleV3 from './webSubtitleV3';
import * as webWhiteboardV3 from './webWhiteboardV3';

export const api = {
  reaction,
  webAvatarV3,
  webCodeEditorV3,
  webFeedbackV3,
  webInterpretChannelV3,
  webMeetingAuthV3,
  webMeetingOpenAuthV3,
  webMeetingV3,
  webMikeControlV3,
  webRecordingV3,
  webScreenShareV3,
  webSettingV3,
  webSubtitleV3,
  webWhiteboardV3,
};
